function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.073.448a.494.494 0 01.057.756L1.41 8l6.72 6.796a.494.494 0 01-.057.756.662.662 0 01-.855-.05L.15 8.353a.49.49 0 010-.706L7.218.498a.662.662 0 01.855-.05z",
  fill: "currentColor"
});

function SvgChevronBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCA5IDE2IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogICAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiCiAgICAgICAgICBkPSJNOC4wNzMxIDAuNDQ3NjA4QzguMzI0OTEgMC42NDI2IDguMzUwNDMgMC45ODEzMjggOC4xMzAwOSAxLjIwNDE4TDEuNDEwODkgNy45OTk5NEw4LjEzMDA5IDE0Ljc5NTdDOC4zNTA0MyAxNS4wMTg2IDguMzI0OTEgMTUuMzU3MyA4LjA3MzEgMTUuNTUyM0M3LjgyMTI4IDE1Ljc0NzMgNy40Mzg1MiAxNS43MjQ3IDcuMjE4MTkgMTUuNTAxOEwwLjE0OTkwMiA4LjM1MzAxQy0wLjA0OTk2NzQgOC4xNTA4NiAtMC4wNDk5Njc0IDcuODQ5MDIgMC4xNDk5MDIgNy42NDY4OEw3LjIxODE5IDAuNDk4MDQ2QzcuNDM4NTIgMC4yNzUxOTcgNy44MjEyOCAwLjI1MjYxNSA4LjA3MzEgMC40NDc2MDhaIgogICAgICAgICAgZmlsbD0iY3VycmVudENvbG9yIgogICAgLz4KPC9zdmc+Cg==";
export { SvgChevronBack as ReactComponent };